import { useEffect, useState } from 'react';
import { getCognitoUserEmail, useUser } from '../context/UserContext';

/**
 * ログインID（メールアドレス）を返す。
 * - 通常ログインでは user.signInDetails.loginId を使う。
 * - Hosted UI（外部IdP）ログインでは signInDetails が付かないため、
 *   Cognito のユーザー属性 email にフォールバックする（取得完了までは空文字）。
 */
export const useLoginId = (): string => {
  const user = useUser();
  const direct = String((user as any)?.signInDetails?.loginId ?? '').trim();
  const hasUser = !!user;
  const userKey = String((user as any)?.userId ?? (user as any)?.username ?? '');
  const [fallback, setFallback] = useState<string>('');

  useEffect(() => {
    if (direct || !hasUser) {
      setFallback('');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const email = String((await getCognitoUserEmail()) ?? '').trim();
        if (!cancelled) setFallback(email);
      } catch {
        if (!cancelled) setFallback('');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [direct, hasUser, userKey]);

  return direct || fallback;
};
